<template>
	<div v-if="showSuggestions" ref="searchHelpSuggestions" class="absolute left-16 tablet:left-0 right-16 tablet:right-48 desktop:right-56 z-10 mt-16 tablet:mt-32 bg-white shadow-sm rounded-6 tablet:rounded-tl-none">
		<ul class="p-16 tablet:py-24 tablet:px-48 desktop:px-56 desktop:mx-auto desktop:max-w-1440">
			<template v-if="fuseResult.length > 0">
				<li v-for="(faq, index) in fuseResult.slice(0, maxResults)" :key="index" class="mb-16 tabletWide:mb-24">
					<nuxt-link :to="faq.url" class="flex alighItems-flexStart text-goBlue hover:text-goPink" @click.native="helpClick">
						<span class="mr-8"><svg-icon name="help" class="iconSize-24" /></span>
						<span>{{ faq.question }}</span>
					</nuxt-link>
				</li>

				<li v-if="fuseResult.length > maxResults" class="mb-16 tabletWide:mb-24">
					<hr class="m-0 border-black/10" />
				</li>

				<li v-if="fuseResult.length > maxResults">
					<button class="text-goBlue hover:text-goPink font-bold cursor-pointer border-0 bg-transparent p-0" @click="showAllResults">See all results <svg-icon name="arrow-forward-small" class="iconSize-24 align-middle ml-8" /></button>
				</li>
			</template>

			<template v-else>
				<li>
					<span class="font-bold">No matches found</span> <br />
					<span class="text-goGrayDark">Please try a different search.</span>
				</li>
			</template>
		</ul>
	</div>
</template>

<script>
export default {
	props: {
		maxResults: {
			type: Number,
			default: 5,
		},
	},
	data() {
		return {
			showSuggestions: false,
		};
	},
	computed: {
		fuseResult() {
			return this.$store.state.help.searchResults;
		},
		searchTerm() {
			return this.$store.state.help.searchTerm;
		},
	},
	watch: {
		$route: {
			handler(search) {
				this.$store.commit("help/updateSearchTerm", "");
			},
			deep: true,
			immediate: true,
		},
		searchTerm() {
			this.showSuggestions = this.searchTerm !== "";
		},
		showSuggestions() {
			if (this.showSuggestions) {
				window.addEventListener("click", this.atClickToggleSuggestions, false);
			} else {
				window.removeEventListener("click", this.atClickToggleSuggestions, false);
			}
		},
	},
	methods: {
		atClickToggleSuggestions(event) {
			this.showSuggestions = typeof this.$refs.searchHelpSuggestions !== "undefined" && this.$refs.searchHelpSuggestions.contains(event.target);
		},
		showAllResults() {
			this.$store.commit("help/updateShowResults", true);
			this.$store.commit("help/updateSearchTerm", "");
			this.$router.push("/help/");
		},
		helpClick() {
			this.$store.commit("help/updateSearchTerm", "");
			this.$store.commit("help/updateResults", []);
			this.$store.commit("help/updateShowResults", false);
		},
	},
};
</script>
